import { render, staticRenderFns } from "./BenzTruck.vue?vue&type=template&id=ec7f6694"
import script from "./BenzTruck.vue?vue&type=script&lang=js"
export * from "./BenzTruck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports